import Ship from './ship.js';

export default class Destroyer extends Ship {
  constructor() {
    super(3, 'destroyer');
  }
}
